module.exports = __webpack_public_path__ + "static/media/Furion.8587a0cf.png";